import { SC_Input } from "../input/SC_Input";
import { Rectangular } from "../roof/Rectangular";
import { Hip } from "../roof/Hip";
import { PartialHip } from "../roof/PartialHip";

export class RoofShape {

    static PULT: number = 0;
    static SATTEL: number = 1;
    static WALM: number = 2;
    static SCHED: number = 3;
    static KRUEPPELWALM: number = 4;
    static MANSARD: number = 5;

    static drawHighlightV2(_x: number, _y: number, _width: number, _height: number) {

    }

    static getCurrentRoofHeight(): number {
        var nRoofHeight: number = 0;
        if (SC_Input.iRoofShape == RoofShape.PULT) {
            nRoofHeight = SC_Input.a;
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            nRoofHeight = SC_Input.a;
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            nRoofHeight = SC_Input.a;
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            nRoofHeight = SC_Input.a;
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            nRoofHeight = SC_Input.a + SC_Input.d;
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            nRoofHeight = SC_Input.a;
        }
        return nRoofHeight;
    }

    public static getCurrentRoofWidth(): number {
        var nRoofWidth: number = 0;
        if (SC_Input.iRoofShape == RoofShape.PULT) {
            nRoofWidth = SC_Input.b;
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            nRoofWidth = SC_Input.b;
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            nRoofWidth = SC_Input.b;
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            nRoofWidth = SC_Input.b;
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            nRoofWidth = SC_Input.b;
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            nRoofWidth = SC_Input.b;
        }
        return nRoofWidth;
    }

    public static getRangeByRect(rect: any): string {
        var sRet: string = "";
        //no range
        if (SC_Input.bNoRange) {
            return "h";
        }
        if (SC_Input.iRoofShape == RoofShape.PULT) {
            sRet = Rectangular.getRangeByModule(rect);
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            sRet = Rectangular.getRangeByModule(rect);
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            sRet = Hip.getRangeByModule(rect);
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            sRet = Rectangular.getRangeByModule(rect);
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            sRet = PartialHip.getRangeByModule(rect);
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            sRet = Rectangular.getRangeByModule(rect);
        }
        return sRet;
    }

    public static drawHighlightH(_x: number, _y: number, _width: number, _height: number) {
        // Global.pageDesign.canHiLi.graphics.lineStyle(2, 0xff0000);
        // Global.pageDesign.canHiLi.graphics.drawEllipse((_x + (_width / 2)) - _height / 6, _y + (_height / 2), _height / 3, _height);
    }

    public static getAreaByModule(mod: any) {
        var sRet: string = "";
        //no range
        if (SC_Input.bNoRange) {
            return "h";
        }
        if (SC_Input.iRoofShape == RoofShape.PULT) {
            sRet = Rectangular.getRangeByModule(mod);
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            sRet = Rectangular.getRangeByModule(mod);
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            sRet = Hip.getRangeByModule(mod);
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            sRet = Rectangular.getRangeByModule(mod);
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            sRet = PartialHip.getRangeByModule(mod);
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            sRet = Rectangular.getRangeByModule(mod);
        }
        return sRet;
    }
}